import DOMPurify from 'dompurify';
import type { Config } from 'dompurify';

const config: Config = {
  FORBID_ATTR: ['style']
};

DOMPurify.setConfig(config);

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (
    'target' in node &&
    node instanceof HTMLElement &&
    node.target === '_blank'
  ) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
});

export function htmlSanitize<TrustedTypes extends boolean = true>(
  input: string,
  trustedTypes: TrustedTypes = true as TrustedTypes
  // eslint-disable-next-line no-undef
): TrustedTypes extends true ? TrustedHTML | string : string {
  return DOMPurify.sanitize(input, {
    RETURN_TRUSTED_TYPE: trustedTypes
  });
}
